<template>
  <v-layout justify-center wrap>
    <v-flex xs8 sm4 lg2>
      <router-link :to="{name:'Register'}">
        <v-img :src="require('../assets/SpLogo.png')"></v-img>
      </router-link>
    </v-flex>
    <v-flex class="text-xs-center" xs12>
      <h1>{{$route.query.msg || "Algo inesperado aconteceu."}}</h1>
      <v-btn :to="{name:'Register'}">
        Voltar
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {

}
</script>

<style>

</style>